import { edeApi } from 'src/api';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
export const OPEN_MODAL_RENEW_STANDARD_TIME = 'OPEN_MODAL_RENEW_STANDARD_TIME';
export const CLOSE_MODAL_RENEW_STANDARD_TIME = ' CLOSE_MODAL_RENEW_STANDARD_TIME';
export const REQUEST_RENEW_STANDARD_TIME = 'REQUEST_RENEW_STANDARD_TIME';
export const FAIL_RENEW_STANDARD_TIME = 'FAIL_RENEW_STANDARD_TIME';
const renewStandardTimeRequest = () => ({ type: REQUEST_RENEW_STANDARD_TIME });
const renewStandardTimeRequestFail = (error) => ({ type: FAIL_RENEW_STANDARD_TIME, error });
export const openModalWindowRenewStandardTime = () => ({ type: OPEN_MODAL_RENEW_STANDARD_TIME });
export const closeModalWindowRenewStandardTime = () => ({ type: CLOSE_MODAL_RENEW_STANDARD_TIME });
export const renewStandardTime = (period) => (dispatch) => {
    dispatch(renewStandardTimeRequest());
    return edeApi.tasks.importTimesForPeriodCreate({ period }).then((response) => {
        toastrSuccess(response);
        dispatch(closeModalWindowRenewStandardTime());
    }).catch((err) => {
        dispatch(renewStandardTimeRequestFail(err));
        toastrError(err);
    });
};
